module.exports = __webpack_public_path__ + "img/post-boston.f5c756a2.jpeg";